module.exports = __webpack_public_path__ + "static/media/step2.ba96741e.png";